'use client'

import React from 'react'
import SavingRegistrantInformation from '@/components/registrant/SavingRegistrantInformation'
import GTMAuthorize from '@/components/gtm/GTMAuthorize'
import { AppView } from '@/components/ui'
import { useAuth } from '@/hooks'

interface Props {
  children: React.ReactNode
}

const AppViewLayout: React.FC<Props> = ({ children }) => {
  const { isAuthorized } = useAuth()

  return (
    <AppView>
      {children}
      {isAuthorized && (
        <>
          <SavingRegistrantInformation />
          <GTMAuthorize />
        </>
      )}
    </AppView>
  )
}

export default AppViewLayout
